import { hexToRgb } from '@website/common/utils'
export default {
  DARK: {
    heading: p => p.accentWhite,
    paragraph: p => p.accentWhite,
    navbarBg: p => p.tertiaryDark,
    blockTitle: p => p.accentWhite,
    blockParagraph: p => p.accentWhite,
    link: p => p.primaryLight,
    background: p => p.tertiaryDark,
    backgroundColor: p => p.tertiaryDark,
    gradientColorFrom: p => p.primaryDark,
    gradientColorTo: p => p.primaryLight,
    border: p => `rgba(${hexToRgb(p.accentWhite)}, 0.3)`
  },
  LIGHT: {
    heading: p => p.primaryDark,
    paragraph: p => p.tertiaryDark,
    navbarBg: p => p.tertiaryLight,
    blockTitle: p => p.primaryDark,
    blockParagraph: p => p.tertiaryDark,
    link: p => p.primaryDark,
    background: p => p.tertiaryLight,
    lightBackground: p => p.tertiaryExtraLight,
    backgroundColor: p => p.tertiaryLight,
    gradientColorFrom: p => p.primaryDark,
    gradientColorTo: p => p.primaryLight,
    border: p => `rgba(${hexToRgb(p.tertiaryDark)}, 0.3)`
  },
  EXTRALIGHT: {
    heading: p => p.tertiaryDark,
    paragraph: p => p.tertiaryDark,
    navbarBg: p => p.tertiaryExtraLight,
    blockTitle: p => p.tertiaryDark,
    blockParagraph: p => p.tertiaryDark,
    link: p => p.primaryDark,
    lightBackground: p => p.tertiaryExtraLight,
    background: p => p.tertiaryExtraLight,
    backgroundColor: p => p.tertiaryExtraLight,
    gradientColorFrom: p => p.primaryDark,
    gradientColorTo: p => p.primaryLight,
    border: p => `rgba(${hexToRgb(p.tertiaryDark)}, 0.3)`
  }
}
